// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hWwQtUvB6K_T5UGvfoam {
  margin-top: 20px;
}

.Vup4hxrjDvRgmpXxNMP0 {
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
  background-color: #f9f9f9;
  min-height: 100px;
  max-height: 1100px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f9f9f9;
  position: relative;
}

.Vup4hxrjDvRgmpXxNMP0::-webkit-scrollbar {
  width: 6px;
}

.Vup4hxrjDvRgmpXxNMP0::-webkit-scrollbar-track {
  background: #f9f9f9;
  border-radius: 3px;
}

.Vup4hxrjDvRgmpXxNMP0::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  transition: background 0.2s ease;
}

.Vup4hxrjDvRgmpXxNMP0::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

.hT7TJEyC1DkwDL822ncT {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ear1sO1eaVC5CA0lBCgK {
  padding: 10px 15px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  background-color: #ffffff;
  transition: background-color 0.3s;
}

.ear1sO1eaVC5CA0lBCgK:hover {
  background-color: #f1f1f1;
}
  
.wmEkT68qmfn0_walD2RF {
  font-size: 20px;
  font-weight: bold;
  margin: 20px 0 10px;
  display: flex;
  align-items: center;
}
  
.YVD40KFtaQ6F42yrRiHE {
  color: red;
  cursor: pointer;
  margin-left: 10px;
}

.Du3gcYvw566zuLmq3bpT {
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
  color: rgb(5, 116, 190);
  display: inline-block;
  width: 28px;
  height: 28px;
  line-height: 26px;
  text-align: center;
  border-radius: 50%;
  transition: all 0.3s;
}

.Du3gcYvw566zuLmq3bpT:hover {
  color: #ffffff;
  background-color: rgb(5, 116, 190);
}

/* Медиа-запросы для адаптации */
@media screen and (max-height: 1400px) {
  .Vup4hxrjDvRgmpXxNMP0 {
    max-height: 1000px;
  }
}

@media screen and (max-height: 1000px) {
  .Vup4hxrjDvRgmpXxNMP0 {
    max-height: 800px;
  }
}

@media screen and (max-height: 700px) {
  .Vup4hxrjDvRgmpXxNMP0 {
    max-height: 500px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/SettingsWindow/Checklists.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,gCAAgC;AAChC;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".checklists {\n  margin-top: 20px;\n}\n\n.checklistTree {\n  margin-top: 15px;\n  padding: 10px;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n  min-height: 100px;\n  max-height: 1100px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 #f9f9f9;\n  position: relative;\n}\n\n.checklistTree::-webkit-scrollbar {\n  width: 6px;\n}\n\n.checklistTree::-webkit-scrollbar-track {\n  background: #f9f9f9;\n  border-radius: 3px;\n}\n\n.checklistTree::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n  transition: background 0.2s ease;\n}\n\n.checklistTree::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}\n\n.checklistList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.checklistItem {\n  padding: 10px 15px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: #ffffff;\n  transition: background-color 0.3s;\n}\n\n.checklistItem:hover {\n  background-color: #f1f1f1;\n}\n  \n.sectionTitle {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 20px 0 10px;\n  display: flex;\n  align-items: center;\n}\n  \n.deleteButton {\n  color: red;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.creatingChecklistPlus {\n  cursor: pointer;\n  font-size: 24px;\n  font-weight: bold;\n  margin-left: 10px;\n  color: rgb(5, 116, 190);\n  display: inline-block;\n  width: 28px;\n  height: 28px;\n  line-height: 26px;\n  text-align: center;\n  border-radius: 50%;\n  transition: all 0.3s;\n}\n\n.creatingChecklistPlus:hover {\n  color: #ffffff;\n  background-color: rgb(5, 116, 190);\n}\n\n/* Медиа-запросы для адаптации */\n@media screen and (max-height: 1400px) {\n  .checklistTree {\n    max-height: 1000px;\n  }\n}\n\n@media screen and (max-height: 1000px) {\n  .checklistTree {\n    max-height: 800px;\n  }\n}\n\n@media screen and (max-height: 700px) {\n  .checklistTree {\n    max-height: 500px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checklists": `hWwQtUvB6K_T5UGvfoam`,
	"checklistTree": `Vup4hxrjDvRgmpXxNMP0`,
	"checklistList": `hT7TJEyC1DkwDL822ncT`,
	"checklistItem": `ear1sO1eaVC5CA0lBCgK`,
	"sectionTitle": `wmEkT68qmfn0_walD2RF`,
	"deleteButton": `YVD40KFtaQ6F42yrRiHE`,
	"creatingChecklistPlus": `Du3gcYvw566zuLmq3bpT`
};
export default ___CSS_LOADER_EXPORT___;
